export default __webpack_public_path__ + "304f4c97ef72cefc7cb430564165a6af.png";